import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { CalendarBlank, FilmSlate, Users } from "@phosphor-icons/react";
import { HeroSection, StatsBar } from "@/components/home/HomeSections";
import { SponsorBanner } from "@/components/home/SponsorBanner";
import { PlayerOfGameBanner } from "@/components/home/PlayerOfGameBanner";
import { SeasonChampionBanner } from "@/components/home/SeasonChampionBanner";
import { MVPRace } from "@/components/home/MVPRace";

const HERO_FALLBACK = "https://images.pexels.com/photos/32600343/pexels-photo-32600343.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function Home() {
  const { settings } = useSettings();
  const [overview, setOverview] = useState(null);
  const [teams, setTeams] = useState([]);
  const [standings, setStandings] = useState([]);
  const [players, setPlayers] = useState([]);

  useEffect(() => {
    api.get("/stats/overview").then((r) => setOverview(r.data)).catch(() => {});
    api.get("/teams").then((r) => setTeams(r.data)).catch(() => {});
    api.get("/standings").then((r) => setStandings(r.data)).catch(() => {});
    api.get("/players").then((r) => setPlayers(r.data)).catch(() => {});
  }, []);

  const heroImages = (settings.hero_images && settings.hero_images.length
    ? settings.hero_images
    : [settings.hero_image_url || HERO_FALLBACK]);
  const slideshowOn = settings.slideshow && heroImages.length > 1;
  const fitClass = settings.hero_fit === "contain" ? "object-contain" : "object-cover";
  const announcements = settings.announcements || [];

  const teamName = (id) => teams.find((t) => t.id === id)?.name || "TBD";
  const topScorer = players
    .filter((p) => (p.points || 0) > 0)
    .sort((a, b) => (b.points || 0) - (a.points || 0))[0] || null;

  const stats = [
    { label: "Teams", value: overview?.teams ?? 0, icon: Users },
    { label: "Players", value: overview?.players ?? 0, icon: Users },
    { label: "Games", value: overview?.games ?? 0, icon: CalendarBlank },
    { label: "Highlights", value: overview?.highlights ?? 0, icon: FilmSlate },
  ];

  return (
    <div data-testid="home-page">
      <HeroSection heroImages={heroImages} slideshowOn={slideshowOn} fitClass={fitClass} announcements={announcements} hero={settings.hero || {}} />
      <StatsBar stats={stats} />
      <SeasonChampionBanner />
      <PlayerOfGameBanner />
      <MVPRace limit={10} />
      <SponsorBanner />
    </div>
  );
}
